import { render, staticRenderFns } from "./Signboard.vue?vue&type=template&id=30aa4166&scoped=true&"
import script from "./Signboard.vue?vue&type=script&lang=js&"
export * from "./Signboard.vue?vue&type=script&lang=js&"
import style0 from "./Signboard.vue?vue&type=style&index=0&id=30aa4166&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aa4166",
  null
  
)

export default component.exports